import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ComponentBase} from "../component-base/component-base.component";
import {
  LoaderContainerComponent,
  SrsLoaderOptions,
  SrsLoaderType
} from "../loader-container/loader-container.component";
import {DataTableComponent, SrsDataTableColumnOptions} from "../data-table/data-table.component";
import {ThemePalette} from "@angular/material/core";
import {
  DatePipe,
  JsonPipe,
  NgClass,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
  NgTemplateOutlet
} from "@angular/common";
import {RouteContainerComponent} from "../route-container/route-container.component";
import {QuickPreviewPanelComponent} from "../quick-preview-panel/quick-preview-panel.component";
import {ActionsContainerComponent} from "../actions-container/actions-container.component";
import {BackButtonComponent} from "../back-button/back-button.component";
import {ManageButtonComponent} from "../manage-button/manage-button.component";

@Component({
  selector: 'quick-dashboard',
  standalone: true,
  imports: [
    NgIf,
    RouteContainerComponent,
    NgTemplateOutlet,
    LoaderContainerComponent,
    NgSwitch,
    NgSwitchCase,
    NgClass,
    DatePipe,
    NgSwitchDefault,
    QuickPreviewPanelComponent,
    DataTableComponent,
    ActionsContainerComponent,
    JsonPipe,
    BackButtonComponent,
    ManageButtonComponent
  ],
  templateUrl: './quick-dashboard.component.html',
})
export class QuickDashboardComponent<TResult> extends ComponentBase implements OnInit, OnDestroy {

  @Input() loaderOptions: SrsLoaderOptions<TResult> = {}
  @Input() loader?: SrsLoaderType<TResult>
  @Input() hasRouterOutlet: boolean = false
  @Input() columnOptions: SrsDataTableColumnOptions = {}
  @Input() heading?: string
  @Input() color: ThemePalette
  @Input() manualReloadToken?: string
  @Input() hideActions: boolean = false
  @Input() hideManageButton: boolean = false
  @Output() loaded = new EventEmitter<TResult>()
  @Output() childRouteDeactivated = new EventEmitter<{
    sender: any,
    eventArgs: any
  }>()
  @Output() childRouteActivated = new EventEmitter<{
    sender: any,
    eventArgs: any
  }>()

  @ViewChild('loaderContainer') loaderContainer?: LoaderContainerComponent<any>

  loadedResult?: TResult

  constructor() {
    super()
  }

  override ngOnInit() {
    super.ngOnInit()
  }

  override ngOnDestroy() {
    super.ngOnDestroy()
  }

  onLoadComplete(result: TResult) {
    this.loadedResult = result
    this.loaded.emit(result)
  }

  onChildRouteEvent(ca: { activated: boolean, eventArgs: any }) {
    console.warn('Route activation event', this.uid, ca.activated)
    if (ca.activated) {
      this.childRouteActivated.next({
        sender: self,
        eventArgs: ca.eventArgs
      })
    }
    else {
      this.childRouteDeactivated.next({
        sender: self,
        eventArgs: ca.eventArgs
      })
    }
  }
}

